import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-footer1',
  templateUrl: './footer1.component.html',
  styleUrls: ['./footer1.component.scss']
})
export class Footer1Component implements OnInit {

  @Input() footer1Type:string;

  constructor() { }

  ngOnInit(): void {
  }

}
